/**
 * ワークフロー一覧の要承認・要対応ボタン → ワークフロー詳細画面遷移に付与する
 * 「アクティブサブステップへ focus する」signal (spec AC-WFW-001 §243、2026-08-19
 * 改訂 D5)。一覧側 (`CaseTable` の click ハンドラ) と詳細画面側
 * (`WorkflowCaseDetail`) の両方が同じ query param 契約を参照するため、
 * page-local ではなくアプリ横断の `src/models/` に置く (個別定義すると
 * key/value がズレて片方だけ改名した時に検知できない)。
 *
 * signal は「フォーカスしてほしい」という意図のみを運び、対象サブステップの
 * 座標そのものは運ばない — 詳細画面が `wfCase.bigSteps` からアクティブ (先頭
 * 未完了) サブステップを自前で導出できるため、新規 proto field は不要
 * (Design Note D5 の判断)。要承認・要対応の両ボタンで signal は同一。
 */
const FOCUS_QUERY_KEY = 'focus'
const FOCUS_ACTIVE_SUBSTEP_VALUE = 'active-substep'

/**
 * 詳細画面への遷移先パスにアクティブサブステップへの focus signal を付与する。
 *
 * `path` が既に query string を持つ場合でも `?` の二重発生や既存 param の
 * 上書き事故なしに合成できるよう `URLSearchParams` 経由で組み立てる (現在の
 * 呼び出し側 (`CaseTable`) は query 無しの `detailPath` しか渡さないため
 * 出力は従来どおり `?focus=active-substep` のまま変わらない)。
 */
export function withActiveSubStepFocus(path: string): string {
  const [base, existingQuery] = path.split('?')
  const params = new URLSearchParams(existingQuery)
  params.set(FOCUS_QUERY_KEY, FOCUS_ACTIVE_SUBSTEP_VALUE)
  return `${base}?${params.toString()}`
}

/** URL の query param が focus signal を含むかどうかを判定する。 */
export function hasActiveSubStepFocusSignal(
  searchParams: URLSearchParams,
): boolean {
  return searchParams.get(FOCUS_QUERY_KEY) === FOCUS_ACTIVE_SUBSTEP_VALUE
}
